export default __webpack_public_path__ + "static/media/1822.5f7b6a57.png";